// @flow
import React from 'react';
import styled from 'styled-components';

const StyledMessageBlock = styled.div`
    text-align: center;
    padding: 80px 0 0 0;
    width: 100%;

    & .message {
        margin: 0;
    }
`;

type MessageBlockProps = {
    message: string,
};

const MessageBlock = (props: MessageBlockProps) => {
    const { message } = props;

    return (
        <StyledMessageBlock>
            <p className="message">
                {message}
            </p>
        </StyledMessageBlock>
    );
};

export default MessageBlock;



// WEBPACK FOOTER //
// ./src/components/MessageBlock/MessageBlock.js